const scoreTypes = {
  GRADED: 'graded',
  PARTIALLY_GRADED: 'partially_graded',
  UNATTEMPTED: 'unattempted',
  NA: 'na',
  IN_PROGRESS: 'in_progress',
};

const childWalkables = [
  {
    id: 'a',
    title: 'Automaton Assembly',
    totalScore: '10',
  },
  {
    id: 'b',
    title: 'Drone Programming',
    totalScore: '100',
  },
  {
    id: 'c',
    title: 'Bipedal Mech Design',
    totalScore: '30',
  },
  {
    id: 'd',
    title: 'Navigation Scripting',
    totalScore: null,
  },
];

const learners = [
  {
    id: 'l',
    name: 'Leo Gill',
    scores: [
      {
        walkableId: 'a',
        scoreType: scoreTypes.GRADED,
        score: 6,
      },
      {
        walkableId: 'b',
        scoreType: scoreTypes.GRADED,
        score: 82,
      },
      {
        walkableId: 'c',
        scoreType: scoreTypes.GRADED,
        score: 21,
      },
      {
        walkableId: 'd',
        scoreType: scoreTypes.NA,
      },
    ],
  },
  {
    id: 'm',
    name: 'June Cha',
    scores: [
      {
        walkableId: 'a',
        scoreType: scoreTypes.GRADED,
        score: 2,
      },
      {
        walkableId: 'b',
        scoreType: scoreTypes.GRADED,
        score: 42,
      },
      {
        walkableId: 'c',
        scoreType: scoreTypes.GRADED,
        score: 8,
      },
      {
        walkableId: 'd',
        scoreType: scoreTypes.NA,
      },
    ],
  },
  {
    id: 'n',
    name: 'Iida Niskanen',
    scores: [
      {
        walkableId: 'a',
        scoreType: scoreTypes.GRADED,
        score: 8,
      },
      {
        walkableId: 'b',
        scoreType: scoreTypes.GRADED,
        score: 80,
      },
      {
        walkableId: 'c',
        scoreType: scoreTypes.PARTIALLY_GRADED,
        score: 10,
      },
      {
        walkableId: 'd',
        scoreType: scoreTypes.NA,
      },
    ],
  },
  {
    id: 'o',
    name: 'Renee Sims',
    scores: [
      {
        walkableId: 'a',
        scoreType: scoreTypes.GRADED,
        score: 6,
      },
      {
        walkableId: 'b',
        scoreType: scoreTypes.GRADED,
        score: 86,
      },
      {
        walkableId: 'c',
        scoreType: scoreTypes.PARTIALLY_GRADED,
        score: 18,
      },
      {
        walkableId: 'd',
        scoreType: scoreTypes.NA,
      },
    ],
  },
  {
    id: 'p',
    name: 'Jonathan Nuñez',
    scores: [
      {
        walkableId: 'a',
        scoreType: scoreTypes.GRADED,
        score: 9,
      },
      {
        walkableId: 'b',
        scoreType: scoreTypes.GRADED,
        score: 92,
      },
      {
        walkableId: 'c',
        scoreType: scoreTypes.PARTIALLY_GRADED,
        score: 16,
      },
      {
        walkableId: 'd',
        scoreType: scoreTypes.NA,
      },
    ],
  },
  {
    id: 'q',
    name: 'Konsta Peura',
    avatarUrl: undefined,
    scores: [
      {
        walkableId: 'a',
        scoreType: scoreTypes.GRADED,
        score: 9,
      },
      {
        walkableId: 'b',
        scoreType: scoreTypes.UNATTEMPTED,
      },
      {
        walkableId: 'c',
        scoreType: scoreTypes.UNATTEMPTED,
      },
      {
        walkableId: 'd',
        scoreType: scoreTypes.NA,
      },
    ],
  },
  {
    id: 'r',
    name: 'Leon Hunt',
    avatarUrl: undefined,
    scores: [
      {
        walkableId: 'a',
        scoreType: scoreTypes.GRADED,
        score: 9,
      },
      {
        walkableId: 'b',
        scoreType: scoreTypes.GRADED,
        score: 82,
      },
      {
        walkableId: 'c',
        scoreType: scoreTypes.IN_PROGRESS,
      },
      {
        walkableId: 'd',
        scoreType: scoreTypes.NA,
      },
    ],
  },
];

export { scoreTypes, childWalkables, learners };
